import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllGroupsUserUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllGroupsUser
  implements GetAllGroupsUserUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllGroupsUserUseCaseInterface.Result>,
  ) {}

  async execute(
    params?: GetAllGroupsUserUseCaseInterface.Params,
  ): Promise<GetAllGroupsUserUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(this.url, {
        entity: params?.entityId,
        course: params?.courseId,
        semester: params?.semesterId,
        curricularUnit: params?.curricularUnitId,
      }),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
